import { render, staticRenderFns } from "./SlCustomerDetailHistoric.vue?vue&type=template&id=0e73c440&lang=pug&"
import script from "./SlCustomerDetailHistoric.vue?vue&type=script&lang=js&"
export * from "./SlCustomerDetailHistoric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SlCustomerDetailHistoric.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VIcon,
})
